// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3fd1Z","content":"LoadingAlert_content__1lVhj"};